import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'constant'
})
export class ConstantPipe implements PipeTransform {

  transform(fields: [any], scope?: String, kitId?: String): any {
    if (kitId) {
      return fields.filter(field => {
        return field.kit_id === Number(kitId);
      });
    }
    if (scope) {
      return fields.filter(field => {
        return field.scope === scope;
      });
    }
    return fields;
  }

}



// WEBPACK FOOTER //
// ./src/app/constant.pipe.ts